import React, { useContext, useEffect, useState } from "react"
import { useFirebaseApp } from "contexts/FirebaseApp"

const UnreadMessageContext = React.createContext<number>(0);

export const useUnreadMessage = () => {
    const umContext = useContext(UnreadMessageContext)
    if (umContext == null) {
        throw new Error("useUnreadMessage() called outside of a UnreadMessage?")
    }
    return umContext
}

const UnreadMessage = ({ children }: { children: JSX.Element }) => {
    const { currentUser, functions } = useFirebaseApp();
    const [unread, setUnread] = useState(0)
    const [updated, setUpdated] = useState(false)
    const channel = new BroadcastChannel('sw-messages');

    const countNewMessage = async (id:string, functions: (data: [string, any]) => Promise<string | number | KV | KV[]>) => {
        const { count } = await functions(["mongo/client", { collection: "messages", countDocuments: { filter: { "targetUser.userID": id, "targetUser.read": { $ne: true } }}}]) as { count: number };
        setUnread(count || 0)
    }

    useEffect(() => {
        const handleMessage = (e:MessageEvent) => {
            console.log('Message received in browser page:', e.data);
            if (e.data === "No unread meessage") setUnread(0)
            else setUpdated(true)
        }
        channel.addEventListener('message', handleMessage);
        return () => { 
            channel.removeEventListener('message', handleMessage);
        }
    }, [])

    useEffect(() => {
        if (!currentUser?.uid) return
        if (updated) setUpdated(false) // step to trigger counting to avoid db is null(happen when direct call counting from handleMessage)
        else if (currentUser?.uid) countNewMessage(currentUser?.uid, functions)
    }, [currentUser?.uid, functions, updated]);
    return (
        <UnreadMessageContext.Provider value={unread}>{children}</UnreadMessageContext.Provider>
    );
};
export default UnreadMessage